import { useLocation, useNavigate } from "react-router";
import { twMerge } from "tailwind-merge";
import { ReactNode, useMemo } from "react";
import { useMediaQuery } from "usehooks-ts";

export type TabType = {
  label: ReactNode;
  route: string;
};

export const PageCollectionNavigation = ({
  tabsLeft,
  tabsRight,
}: {
  tabsLeft?: TabType[];
  tabsRight?: TabType[];
}) => {
  const memoTabsLeft = useMemo(() => tabsLeft, [tabsLeft]);
  const memoTabsRight = useMemo(() => tabsRight, [tabsRight]);

  const isDesktop = useMediaQuery("(min-width: 1200px)");

  return (
    <div className="flex w-full border-b border-zinc-300">
      {memoTabsLeft && (
        <div className={twMerge("flex items-center", !isDesktop && "w-full")}>
          {memoTabsLeft.map((tab, idx) => (
            <Tab key={idx} tab={tab} />
          ))}
        </div>
      )}
      {memoTabsRight && isDesktop && (
        <div className="ml-auto flex items-center">
          {memoTabsRight.map((tab, idx) => (
            <Tab key={idx} tab={tab} />
          ))}
        </div>
      )}
    </div>
  );
};

const Tab = ({ tab }: { tab: TabType }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const tabRouteBasePath = new URL(tab.route, window.location.origin).pathname;

  const isDesktop = useMediaQuery("(min-width: 1200px)");

  return (
    <div
      onClick={() => navigate(tab.route)}
      className={twMerge(
        "flex w-full grow cursor-pointer justify-center border-b-4 border-transparent px-2 py-4 text-center font-semibold text-zinc-500 hover:bg-zinc-100",
        location.pathname === tabRouteBasePath &&
          "border-zinc-800 text-zinc-800",
        isDesktop && "max-w-48 min-w-[120px]",
      )}
    >
      <span className="flex items-center gap-1">{tab.label}</span>
    </div>
  );
};
